import { Fragment } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { NotificationProvider } from "../components/Notification";
import ScrollToTop from "../components/ScrollToTop";
import { Layout } from "../layout";
import ExpertiseServiceManagement from "../pages/ExpertiseServiceManagement";
import FirmManagement from "../pages/FirmManagement";
import PageNotFound from "../pages/PageNotFound";
import CommerceLandingPage from "../pages/commerceLandingPage";
import CommerceProfile from "../pages/commerceProfile";
import { CompareServicePage } from "../pages/compareService";
import Dashboard from "../pages/dashboard";
import DashboardStaff from "../pages/dashboardStaff";
import { InboxMessagePage } from "../pages/inboxMessage";
import { SearchFirmTab } from "../pages/searchServices/tabsSearchFirm/searchFirmTab";
import { SearchProductTab } from "../pages/searchServices/tabsSearchProduct";
import { SearchSecondmentTab } from "../pages/searchServices/tabsSearchSecondment";
import { SearchServiceTab } from "../pages/searchServices/tabsSearchService";
import AuthLayout from "./AuthLayout";
import MainLayout from "./MainLayout";
import MiddlewareByRoleComp from "./MiddlewareByRoleComp";
import InquiryManagement from "../pages/inquiryManagement";

export interface AuthHandleProps {
	token: string;
}

export default function AuthHandle({ token }: AuthHandleProps) {
	const queryClient = new QueryClient();

	return (
		<QueryClientProvider client={queryClient}>
			<Router>
				<ScrollToTop />
				<Fragment>
					<NotificationProvider>
						<Layout>
							<Routes>
								<Route element={<AuthLayout token={token} />}>
									<Route element={<MainLayout />}>
										{/* <Route
											path="/"
											element={<SearchServices />}
										/> */}
										<Route
											path="/"
											element={<CommerceLandingPage />}
										/>
										<Route element={<MiddlewareByRoleComp notHave roles={["VendorUser"]} />}>
											<Route
												path="/search-firms"
												element={<SearchFirmTab />}
											/>
											<Route
												path="/search-services"
												element={<SearchServiceTab />}
											/>
											<Route
												path="/search-products"
												element={<SearchProductTab />}
											/>
											<Route
												path="/search-secondments"
												element={<SearchSecondmentTab />}
											/>
										</Route>
										<Route element={<MiddlewareByRoleComp roles={["Admin"]} />}>
											<Route
												path="admin-firm-management"
												element={<FirmManagement />}
											/>
										</Route>
										<Route element={<MiddlewareByRoleComp roles={["Admin"]} />}>
											<Route
												path="admin-service-management"
												element={
													<ExpertiseServiceManagement />
												}
											/>
										</Route>

										<Route
											path="/commerceLandingPage"
											element={<CommerceLandingPage />}
										/>
										<Route
											path="/commerceProfile/:id"
											element={<CommerceProfile />}
										/>
										<Route
											path="/inquiry"
											element={<InboxMessagePage />}
										/>
										<Route
											path="/compare-service"
											element={<CompareServicePage />}
										/>
										<Route element={<MiddlewareByRoleComp roles={["Admin"]} />}>
											<Route
												path="/dashboard-admin"
												element={<DashboardStaff />}
											/>
										</Route>

										<Route element={<MiddlewareByRoleComp roles={["Admin"]} />}>
											<Route
												path="/inquiry-management"
												element={<InquiryManagement />}
											/>
										</Route>

										<Route
											path="/dashboard"
											element={<Dashboard />}
										/>

									</Route>
								</Route>
								<Route path="/404" element={<PageNotFound />} />
								<Route path="*" element={<PageNotFound />} />
							</Routes>
						</Layout>
					</NotificationProvider>
				</Fragment>
			</Router>
		</QueryClientProvider>
	);
}

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
